// @flow

import { getSafeCheckoutPaymentOptions, type OpenedIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getEWalletCheckoutPaymentOptions } from '@tectonics/prs/incoming-payment/checkout-payment-options';

export function getSupportedEwallets(incomingPayment: OpenedIncomingPayment): ImmutableArray<string> {
  const checkoutPaymentOptions = getSafeCheckoutPaymentOptions(incomingPayment);

  return getEWalletCheckoutPaymentOptions(checkoutPaymentOptions);
}
